import { render, staticRenderFns } from "./CategoryDropDownTree.vue?vue&type=template&id=0620170c"
import script from "./CategoryDropDownTree.vue?vue&type=script&lang=js"
export * from "./CategoryDropDownTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryDropDownTree.vue?vue&type=style&index=0&id=0620170c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports